import PropTypes from 'prop-types';
import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/pro-light-svg-icons/faChevronLeft";

export const CONTROL_PREV = "CONTROL_PREV"
export const CONTROL_NEXT = "CONTROL_NEXT"
export const CONTROL_NOICON = "CONTROL_NOICON"

function StepControlButton(props) {


    return (
        <button
            type="button"
            onMouseOver={(e) => {
                props.onMouseOver()
            }}
            onClick={props.onClick}
            className={
                "step-control-button"
                + (props.type === CONTROL_PREV ? ' step-control-button--prev' : (props.type === CONTROL_NEXT ? ' step-control-button--next' : ' step-control-button--noicon'))
                + (props.disabled ? ' step-control-button--disabled' : '')
                + (props.showSpinner ? ' step-control-button--spinner' : '')
            }
        >
            {props.type === CONTROL_PREV ? <FontAwesomeIcon icon={faChevronLeft}/> : null}
            {props.showSpinner ? <span className="spinner spinner--white"></span> : props.label}
            {props.type === CONTROL_NEXT ? <FontAwesomeIcon icon={faChevronLeft} flip={"horizontal"}/> : null}
        </button>
    );

}

StepControlButton.propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    showSpinner: PropTypes.bool,
    onMouseOver: PropTypes.func
};

StepControlButton.defaultProps = {
    disabled: false,
    showSpinner: false,
    onMouseOver: () => {
    }
};

export default StepControlButton



/** WEBPACK FOOTER **
 ** ./src/components/navigation/StepControlButton.js
 **/